// app/(lib)/actions/submissionPageAction.ts
"use server";

import { submissionPageService, SubmissionPageDataWithTranslations } from "../services/submissionPageService";
import { extractDomain } from "../utils/domain";

/**
 * Fetch submission page content from API
 */
export async function getSubmissionPageDataAction(franchiseeId?: string | null, language?: string | null) {
  try {
    const domain = await extractDomain();
    
    const submissionPageData = await submissionPageService.fetchByDomain(domain, franchiseeId, language);
    
    return {
      success: true,
      data: submissionPageData,
    };
  } catch (error) {
    console.error("[getSubmissionPageDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
